var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-btn',_vm._g(_vm._b({staticClass:"ml-2 mt-2",attrs:{"fab":"","dark":"","x-small":"","color":"#3dbdad","to":{
        name: _vm.actionName,
        params: { id: _vm.id }
      }}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v(" fas fa-edit ")])],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t("EDIT")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }